const messages = {
  title: "Moj profil",
  desc: "Dobrodošli v vaš osebni prostor. Tu lahko posodobite ali prilagodite svoje <br/>podatke in preverite vašo prejeto pošto.",
  descStaff:
    "Dobrodošli v vaš osebni prostor. Tu lahko posodobite ali prilagodite svoje podatke.",
  buttons: {
    showProfile: "Prikaži profil",
    userProfile: "POJDI NA OSNOVNE PODATKE",
    mailbox: "POJDI NA PREJETO POŠTO",
    addNewEmail: "Dodaj nov e-naslov",
  },
  categories: {
    baseData: {
      title: "Osnovni podatki",
      desc: "Izpolnite svoje osebne in podatke o podjetju za pravilno registracijo.",
    },
    mailbox: {
      desc: "Prejemajte pomembna obvestila in novice v vašo prejeto pošto.",
    },
    bankstatement: {
      title: "Izvještaj računa",
      desc: "Tu lahko preverite status vašega osebnega Bridgestone Plus računa in pregledate vaše zaslužene in uporabljene nagradne točke.",
    },
  },
  profile: {
    general: "OSOBNI PODATKI PODATKI O PODJETJU",
    title: "Osnovni podatki",
    description:
      "Dobrodošli v vaš osebni prostor. Tu lahko posodobite ali prilagodite svoje podatke.",
    block_description:
      "Dobrodošli v vaš osebni prostor. Tu lahko pregledate svoje podatke",
    personalData: "OSOBNI PODATKI",
    password: "Geslo",
    password1: "Geslo (neobvezno)*",
    password2: "Geslo (ponovi)*",
    formOfAddress: "Naziv",
    choose: "Izberi naziv",
    mr: "Gospod",
    mrs: "Gospa",
    diverse: "Drugo",
    firstname: "Ime",
    surname: "Priimek",
    position: "POLOŽAJ V PODJETJU",
    operatingData: "PODATKI O PODJETJU",
    company: "Podjetje",
    legalForm: "Pravna struktura",
    name: "Ime",
    streetHouseNr: "Naslov podjetja",
    street: "Ulica",
    postcode: "Poštna številka",
    location: "Mesto",
    country: "Država",
    de: "Nemčija",
    at: "Avstrija",
    ch: "Švica",
    nl: "Nizozemska",
    it: "Italija",
    language: "Jezik",
    french: "Francoščina",
    italian: "Italijanščina",
    german: "Nemščina",
    nederland: "Nizozemščina",
    phone: "Telefon",
    website: "Spletna stran",
    operatingIndicators: "Ključni operativni kazalniki",
    tireSale: "Letna prodaja pnevmatik pribl. v enotah",
    tireSaleLabel: "Prodajajte pnevmatike v velikih količinah",
    inches: "Od katerih ≥ 18 palcev (v %)",
    inchesLabel: "Od katerih 18 palcev ali več v %",
    segmentSale:
      "Prodaja pnevmatik po segmentih (delež Budget / Mid / Premium v %)",
    premBudget: "Premium",
    midBudget: "Srednje",
    budBudget: "Budget",
    distribution: "DISTRIBUCIJA POZIMI / ZIMA / VSE SEZONE (v %)",
    summerIn: "Proti poletju",
    winterIn: "Zima je tu",
    allSeasonIn: "Celo sezono",
    tyreSizes: "Število sezonskih skladiščnih mest (kompleti pnevmatik)",
    diffDeliveryAddres: "Dodaj naslov za dostavo",
    yourEmailAddress: "Vaš e-naslov.",
    clientNr: "Številke strank",
    clientNrSingular: "Številka stranke",
    clientNrContent:
      "<span class='text-danger fw-bold'>POMEMBNO - PROSIMO PREBERITE:</span><br /><br /> Za pravilno dodeljevanje vaših nakupov pnevmatik pri veleprodajalcu in/ali Bridgestone je potrebno <b>navesti vaše ustrezne številke strank.</b><br/><br/>Če imate <b>več številk strank pri veleprodajalcu in/ali Bridgestone,</b> npr. za vašo glavno trgovino in podružnice, prosimo najprej navedite številko stranke glavne trgovine.<br/><br/><b>Prodaja z drugih številk strank bo nato pripisana vaši glavni trgovini.</b>",
    supplySource: "Vir dobave",
    email: "E-naslov",
    staffEmail: "E-naslov udeleženca",
    registered: "Registriran",
    registeredAt: "Registriran",
    lastLogIn: "Zadnja prijava",
    details: "Podrobnosti",
    inDetail: "{name} podrobno",
    customerFile: "Kartica stranke",
    customerHistory: "Zgodovina stranke",
    currentYear: "Tekoče leto",
    bsClientNr: "Vaša Bridgestone številka stranke",
    bftClientNr: "Vaša Best4Tires številka stranke",
    acceptTerms: "Sprejmite pogoje in določila za sodelovanje.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>POMEMBNO - PROSIMO PREBERITE:</span><br />Pri prvem vnosu številk strank bodo vaši podatki preverjeni za točnost in skladnost z našimi kriteriji distribucije. Odločitev o aktivaciji številke(ev) stranke in povezovanju z vašim profilom lahko traja do 5 delovnih dni.",
    selectWholeSaler: "pri dobavitelju (prosimo izberite)",
    cooperation: "ČLANSTVO / SODELOVANJE",
    error100: "Vsota vrednosti mora biti enaka 100%.",
    errorRange: "Vrednost mora biti med 0 in 100",
    btw_number_label: "DDV registrska številka vašega podjetja",
    btw_number: "DDV registrska številka",
    mobile: "Telefonska številka",
    mobile_label: "Vaša mobilna telefonska številka",
    iban_number: "IBAN številka vašega podjetja",
    iban_number_label: "IBAN številka",
    yourCsNr: "Vaše številke strank",
    yourLastName: "Vaš priimek",
    positionLabel: "Izberi položaj",
    yourFirstName: "Vaše ime",
    companyLabel: "Podjetje",
    numberOfSetsOfSeasonalTiresBudget: "Letno skladiščenje",
    contactInfo: "Če imate vprašanja, prosimo kontaktirajte nas: {email}",
    addAnotherCsNumber: "Dodaj še eno Bridgestone številko stranke",
    activityAndProfile: "POSLOVNE OPERACIJE IN PROFIL",
    financialEmail: "Finančni e-naslovi",
    indirectCustomNumberHelpMessage:
      "No pudimos detectar la configuración de tu número de cliente. Por favor, revisa tu perfil y confirma si eres un cliente directo o indirecto para continuar.",
    completeProfile: "Izpolnite svoj osebni profil in dodatno",
    completeProfileBold: "zagotovite si 200 točk.",
  },
  countries: {
    al: "Albanija",
    ad: "Andora",
    at: "Avstrija",
    be: "Belgija",
    by: "Belorusija",
    ba: "Bosna in Hercegovina",
    bg: "Bolgarija",
    hr: "Hrvaška",
    cy: "Ciper",
    cz: "Češka",
    dk: "Danska",
    ee: "Estonija",
    fi: "Finska",
    fr: "Francija",
    ge: "Gruzija",
    gr: "Grčija",
    es: "Španija",
    nl: "Nizozemska",
    ie: "Irska",
    is: "Islandija",
    kz: "Kazahstan",
    xk: "Kosovo",
    li: "Lihtenštajn",
    lt: "Litva",
    lu: "Luksemburg",
    lv: "Latvija",
    mk: "Severna Makedonija",
    mt: "Malta",
    md: "Moldavija",
    mc: "Monako",
    de: "Nemčija",
    no: "Norveška",
    pl: "Poljska",
    pt: "Portugalska",
    ru: "Rusija",
    ro: "Romunija",
    sm: "San Marino",
    rs: "Srbija",
    sk: "Slovaška",
    si: "Slovenija",
    se: "Švedska",
    ch: "Švica",
    tr: "Turčija",
    ua: "Ukrajina",
    hu: "Madžarska",
    gb: "Združeno kraljestvo",
    it: "Italija",
    va: "Vatikan",
  },
  addCsNumber: {
    title: "Obvestilo",
    body: "Ali ste prepričani, da želite shraniti to številko stranke? Dejanje blokira urejanje podatkov, dokler jih administrator ne odobri.",
  },
  extraEmailSection: {
    description:
      "Dodatni e-naslovi se izključno uporabljajo za pošiljanje BS+ marketinških informacij in/ali finančnih informacij in <b>se v nobenem primeru ne smejo uporabljati za prijavo ali upravljanje</b> Bridgestone PLUS računa.",
    optionOne: "Za finančne informacije (npr. specifikacija bonusa)",
    optionTwo:
      "Za Bridgestone Plus marketinško komunikacijo (npr. promocije/bilteni)",
    addNewEmail: "Dodaj nov e-naslov",
  },
};

export default {
  messages,
};
